import { Container } from "unstated";

import _ from "lodash";

import { formatTime } from "../../lib/formatters";

class ErrorContainer extends Container {
  constructor(serviceContainer, props = {}) {
    super(props);

    this.serviceContainer = serviceContainer;

    this.state = {
      errorMessage: undefined,
      occurredOn: undefined
    };
  }

  getError() {
    return this.state.errorMessage;
  }

  getOccurredOn() {
    return formatTime(this.state.occurredOn);
  }

  setError(msg) {
    this.setState({ errorMessage: msg, occurredOn: new Date() });
  }

  clearError() {
    this.setState({ errorMessage: undefined, occurredOn: undefined });
  }

  hasError() {
    return !_.isNil(this.getError());
  }
}

export { ErrorContainer };
